// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__9O8sB","text":"SelectPayment_text__2BimP","title":"SelectPayment_title__wnSdf","btn":"SelectPayment_btn__f8bf2"};